import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { useMutation } from "@apollo/client";
import { zodResolver } from "@hookform/resolvers/zod";

import { FormGroup } from "@cofano/cck";

import { FormDialog } from "components/dialogs/Dialogs";
import DatePicker from "components/cck/DatePicker";

import { updateBerthingWindowSchema, UpdateBerthingWindowSchemaInput, UpdateBerthingWindowSchemaOutput } from "view/connectingVisits/utils/connectingvisit.schema";

import { EditBerthingWindowDocument } from "__generated__/view/connectingVisits/graphql/connectingVisit.mutations.generated";

const UpdateBerthingWindowDialog = ({ open, onClose, berthing, refetch }: {
	open: boolean,
	onClose: () => void,
	berthing: {
		id: number;
		from: number | null,
		to: number | null,
	}
	refetch: () => void,
}) => {

	const { control, handleSubmit, reset } = useForm<UpdateBerthingWindowSchemaInput, unknown, UpdateBerthingWindowSchemaOutput>({
		resolver: zodResolver(updateBerthingWindowSchema),
		defaultValues: {
			from: null,
			to: null,
		},
	});

	const handleOnClose = () => {
		onClose();
		reset({
			from: null,
			to: null,
		});
	};

	const [ editBerthingWindow, { loading } ] = useMutation(EditBerthingWindowDocument);

	const save = (data: UpdateBerthingWindowSchemaOutput) => {
		editBerthingWindow({
			variables: {
				id: berthing.id,
				from: data.from,
				to: data.to,
			},
		}).then(() => {
			refetch();
			handleOnClose();
		});
	};

	useEffect(() => {
		if (open) {
			reset({
				from: berthing.from,
				to: berthing.to,
			});
		}
	}, [ open ]);

	return (
		<FormDialog
			open={open}
			onClose={handleOnClose}
			title={intl.formatMessage({ id: "CONNECTING_VISIT_BERTHING_WINDOW" })}
			form='updateBerthingWindowForm'
			loading={loading}>
			<form onSubmit={(event) => void handleSubmit(save)(event)} id="updateBerthingWindowForm">
				<FormGroup label={intl.formatMessage({ id: "FROM" })} overflow="hidden">
					<Controller
						name="from"
						control={control}
						render={({ field }) => <DatePicker { ...field } showTimeInput autoFocus />} />
				</FormGroup>

				<FormGroup label={intl.formatMessage({ id: "TO" })} overflow="hidden">
					<Controller
						name="to"
						control={control}
						render={({ field }) => <DatePicker { ...field } showTimeInput />} />
				</FormGroup>
			</form>
		</FormDialog>
	);
};

export default UpdateBerthingWindowDialog;
